module.exports = __webpack_public_path__ + "static/img/application6-6.323ef2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application6-6.jpg
// module id = 4fE3
// module chunks = 0